<!-- 文章列表 -->
<template>
    <div v-if="componentsData.type == 7"
        :style="`
            padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px; background: ${componentsData.content.bg_color};
            border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;
        `"
    >
        <div :style="`height: ${componentsData.content.height}px;`">
            <div class="header">
                <span class="fw-6 fs-18" :style="`color: ${componentsData.content.big_title_color};`"> {{componentsData.content.title}} </span>
            </div>
            <div class="pt-6">
                <div class="flex-sb">
                    <div class="fw-6 fs-16" :style="`color: ${componentsData.content.title_color};`">
                        {{componentsData.content.articleData.title}}
                    </div>
                    <div v-if="componentsData.content.time_value" :style="`color: ${componentsData.content.time_color}`">
                        {{componentsData.content.articleData.created_at}}
                    </div>
                </div>
                <div :style="`color: ${componentsData.content.text_color}`">{{componentsData.content.articleData.content}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.header {
    padding: 0 0 6px 0;
    border-bottom: 1px solid #ccc;
}
.fw-6 {
    font-weight: 600;
}
.fs-18 {
    font-size: 18px;
}
.pt-6 {
    padding: 6px 0 0 0;
}
.fs-16 {
    font-size: 16px;
}
</style>